import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../lib/api'

export function useEventStats() {
  return useQuery({
    queryKey: ['events', 'stats'],
    queryFn: () => apiFetch<{ data: { upcomingEvents: number } }>('/events/stats'),
    staleTime: 5 * 60 * 1000,
  })
}
